import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { uploadNewDocVersion } from "../../api/document";

export const NewVersionModal = ({
  isOpen,
  onOpen,
  onClose,
  docId,
  refresh,
}) => {
  const fileUploadRef = useRef(null);
  const user = useSelector(state => state.user);
  const [uploading, setUploading] = useState(false);

  const uploadNewVersion = () => {
    setUploading(true);
    const file = fileUploadRef.current.files[0];

    if (!file) {
      toast("Please select a file", { type: "error" });
      setUploading(false);
      return;
    }

    uploadNewDocVersion({ docId, file, token: user.token })
      .then(res => {
        if (res === null) {
          toast("Something went wrong", { type: "error" });
          return;
        }

        setUploading(false);
        toast("New version uploaded", { type: "success" });
        refresh();
        onClose();
      })
      .catch(e => {
        console.log(e);
        toast("Something went wrong", { type: "error" });
      })
      .finally(() => setUploading(false));
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4  sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                <div>
                  <div>
                    <Dialog.Title className="text-xl text-gray-900 font-bold">
                      Upload a new version
                    </Dialog.Title>

                    <div className="mt-4">
                      <label className="block">
                        <input
                          ref={fileUploadRef}
                          type="file"
                          className="cursor-pointer block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                  <button
                    type="button"
                    className={`w-full inline-flex justify-center rounded-md border h-10 border-transparent shadow-sm  bg-black-600  text-white hover:bg-black-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500 sm:col-start-2 sm:text-sm btn btn-sm ${
                      uploading && "loading"
                    }`}
                    onClick={uploadNewVersion}
                  >
                    Upload
                  </button>
                  <button
                    type="button"
                    className={`mt-3 w-full inline-flex justify-center rounded-md border  h-10 border-gray-300 shadow-sm  bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500 sm:mt-0 sm:col-start-1 sm:text-sm btn btn-sm ${
                      uploading && "loading"
                    }`}
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
